import { render, staticRenderFns } from "./AssetCategoriesManager.vue?vue&type=template&id=5e671453&scoped=true"
import script from "./AssetCategoriesManager.vue?vue&type=script&lang=js"
export * from "./AssetCategoriesManager.vue?vue&type=script&lang=js"
import style0 from "./AssetCategoriesManager.vue?vue&type=style&index=0&id=5e671453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e671453",
  null
  
)

export default component.exports